import { render } from "./AttachmentCard.vue?vue&type=template&id=868eeeec&scoped=true"
import script from "./AttachmentCard.vue?vue&type=script&lang=js"
export * from "./AttachmentCard.vue?vue&type=script&lang=js"

import "./AttachmentCard.vue?vue&type=style&index=0&id=868eeeec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-868eeeec"]])

export default __exports__